// import { useState } from 'react'; 개인정보처리방침 사용시 해제
import './Footer.css';
// import PrivacyModal from '../../../Components/Common/Privacy/PrivacyModal.js'; 개인정보처리방침 사용시 해제

function Footer() {
    // const [modalShow, setModalShow] = useState(false); // 모달 상태 관리 개인정보처리방침 사용시 해제

    return (
        <footer className="custom-footer allow-drag">
            <div className="container">
                <div className="row align-items-end"> {/* 하단 라인 정렬을 위해 추가 */}
                    <div className="col-md-7 mb-4 text-start">
                        <h5 className="fw-bold mb-3 footer-title">법률사무소 온평</h5>
                        <div className="footer-info">
                            <p className="small mb-1">대표변호사: 배원식 | 사업자등록번호: 601-46-25710</p>
                            <p className="small mb-1">주소: 서울 서초구 서초대로45길 20 (서초동) 510호</p>
                            <p className="small">Tel: 010-4087-0375 | Email: njnjj2002@kakao.com</p>
                        </div>
                    </div>

                    <div className="col-md-5 text-md-end">
                        {/* 개인정보처리방침 사용시 해제 */}
                        {/* <div className="footer-links mb-3">
                            <span
                                className="privacy-link fw-bold"
                                style={{ cursor: 'pointer' }}
                                onClick={() => setModalShow(true)}
                            >
                                개인정보 처리방침
                            </span>
                        </div> */}
                        <p className="small mb-1 text-muted">
                            본 사이트의 모든 콘텐츠는 저작권법의 보호를 받습니다.
                        </p>
                        <p className="small opacity-75 mb-0">
                            © 2026 LAW FIRM ONPYEONG. All rights reserved.
                        </p>
                    </div>
                </div>
            </div>
            {/* <PrivacyModal show={modalShow} onHide={() => setModalShow(false)} /> 개인정보처리방침 사용시 해제*/}
        </footer>
    );
}

export default Footer;